import { useState } from "react";
import CustomModel from "../../Utility/CustomModel";
import { toast } from "react-toastify";
import { addTableFootnote, addTextFootnote } from "../../Utility/tablelist";

const FootNoteModal = ({ editor, note, setOpen }) => {
  const [notes, setNotes] = useState(null);

  const handleCancel = () => {
    setOpen({
      open: false,
      type: null,
      node: null,
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (note.type === "table") {
  //     const tableWrap = editor.dom.getParent(note.node, "table-wrap");
  //     const tableFoot = tableWrap?.querySelector("table-wrap-foot");

  //     if (tableFoot) {
  //       const foot = tableFoot.querySelectorAll("fn");
  //       const lastId = foot[foot.length - 1].getAttribute("id");
  //       const id = tableWrap.getAttribute("id");
  //       const fn2 = document.createElement("fn");
  //       fn2.setAttribute("id", `${id}fn${lastId + 1}`);
  //       fn2.setAttribute("fn-type", "other");
  //       const p2 = document.createElement("p");
  //       p2.textContent = notes;
  //       fn2.appendChild(p2);
  //       tableFoot.appendChild(fn2);
  //     } else if (tableWrap) {
  //       const id = tableWrap.getAttribute("id");

  //       const foot = document.createElement("table-wrap-foot");

  //       const fn1 = document.createElement("fn");
  //       fn1.setAttribute("id", `${id}fn`);
  //       const p1 = document.createElement("p");
  //       const bold = document.createElement("bold");
  //       bold.textContent = "Note:";
  //       p1.appendChild(bold);
  //       fn1.appendChild(p1);

  //       const fn2 = document.createElement("fn");
  //       fn2.setAttribute("id", `${id}fn1`);
  //       fn2.setAttribute("fn-type", "other");
  //       const p2 = document.createElement("p");
  //       p2.textContent = notes;
  //       fn2.appendChild(p2);

  //       foot.appendChild(fn1);
  //       foot.appendChild(fn2);

  //       tableWrap.appendChild(foot);
  //       toast.success("Table Footnote added");
  //     }
  //   } else if (note.type === "text") {
  //       const foot = document.createElement("fn");
  //       const label = document.createElement("label");
  //       const p1 = document.createElement("p");
  //       const existingFns = editor.getBody().querySelectorAll("fn");
  //       let maxNumber = 0;

  //       existingFns.forEach((fn) => {
  //         const id = fn.getAttribute("id");
  //         const match = id && id.match(/^fn-(\d+)$/);

  //         if (match) {
  //           const num = parseInt(match[1]);
  //           if (num > maxNumber) {
  //             maxNumber = num;
  //           }
  //         }
  //       });
  //       if (maxNumber) {
  //         foot.setAttribute("id", `fn-${maxNumber + 1}`);
  //         label.innerHTML = maxNumber + 1;
  //         foot.appendChild(label);
  //       } else {
  //         foot.setAttribute("id", `fn-1`);
  //         label.innerHTML = 1;
  //         foot.appendChild(label);
  //       }
  //       p1.innerHTML = notes;
  //       foot.appendChild(p1);
  //       if (note.node.nextSibling && note.node.nextSibling.tagName.toLowerCase() === "fn") {
  //         note.node.nextSibling.insertAdjacentElement("afterend", foot);
  //       } else {
  //         note.node.insertAdjacentElement("afterend", foot);
  //       }
  //   }
  //   handleCancel();
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    editor.undoManager.transact(() => {
      if (note.type === "table") {
        const response = addTableFootnote(editor, note, notes);
        if (response) {
          toast.success("Table FootNote Added");
        }
      } else if (note.type === "text") {
        const response = addTextFootnote(editor, note, notes);
        if (response) {
          toast.success("Text FootNote Added");
        }
      }
    });
    handleCancel();
  };

  return (
    <div className="w-fit h-fit">
      <CustomModel
        handleCancel={handleCancel}
        heading={"Add FootNote"}
        width={"300px"}
        show={note.open}
      >
        <form onSubmit={(e) => handleSubmit(e)} className="flex flex-col mt-5">
          <label htmlFor="notes">Notes :</label>
          <textarea
            className="outline-none border border-grey min-h-[100px] my-2"
            onChange={(e) => setNotes(e.target.value)}
            name="notes"
            id="footnote"
            value={notes}
          ></textarea>
          <div className="ml-auto">
            <div className="flex py-3 ml-auto gap-4">
              <button
                className=" px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
                onClick={() => handleCancel()}
              >
                {" "}
                Cancel
              </button>
              <button
                className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </CustomModel>
    </div>
  );
};

export default FootNoteModal;
